module.exports = __webpack_public_path__ + "static/media/tache_bg.005df292.svg";